import {
  generateTableHtml,
  tableHtmlWrapper
} from '@/utils/generate-html/table'

import {
  materialColumnTypeDict,
  materialTemplateDefineTypeDict
} from '@/dictionary/material/template'

import { strToThousands } from '@/utils/utils'

import nzhcn from 'nzh/cn'

/**
 * 转换后台返回的基础字段模板，添加用于前端交互的字段
 */
export function setColumnConfig(defineList) {
  let columnConfig = []
  let nameConfig = {} // 品目名称字段
  let numConfig = {} // 采购量的模板配置
  let unitConfig = {} // 采购单位的模板配置
  let codeConfig = {} // 品目编码的模板配置
  let unitPriceConfig = {} // 预算单价的模板配置
  let modelConfig = {} // 参数型号的模板配置
  let controlPriceConfig = {} // 控制价
  columnConfig = (defineList || []).map(item => {
    return {
      columnName: item.columnName,
      // 字段类型为品目名称的或自定义的，均可以修改名称
      canEditColumnName:
        item.columnType === materialColumnTypeDict.NAME.value ||
        item.columnType === materialColumnTypeDict.CUSTOM.value,
      defineType: item.defineType,
      defineCode: item.defineCode,
      supplierRequire: item.supplierRequire,
      supplierVisible: item.supplierVisible,
      enable: item.isEnable === 1,
      isEnable: item.isEnable,
      columnType: item.columnType,
      // 字段类型为参数型号或自定义的，可以设置是否启用
      canEditEnable:
        item.columnType === materialColumnTypeDict.CUSTOM.value ||
        item.columnType === materialColumnTypeDict.MODEL.value
    }
  })

  nameConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.NAME.value
    ) || {}

  codeConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.CODE.value
    ) || {}

  numConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.NUM.value
    ) || {}

  unitConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.UNIT.value
    ) || {}

  unitPriceConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.UNIT_PRICE.value
    ) || {}

  modelConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.MODEL.value
    ) || {}

  controlPriceConfig =
    columnConfig.find(
      item => item.columnType === materialColumnTypeDict.CONTROL_PRICE.value
    ) || {}
  if (controlPriceConfig.columnName) {
    controlPriceConfig.columnName = controlPriceConfig.columnName.replace(
      '（元）',
      ''
    )
  }

  return {
    columnConfig,
    nameConfig,
    codeConfig,
    numConfig,
    unitConfig,
    unitPriceConfig,
    modelConfig,
    controlPriceConfig
  }
}

/**
 * 设定用于表格展示的相应信息模板
 */
export function setTableConfig(columnConfig) {
  const materielInfoConfig = []
  const purchaseSpecifyConfig = []
  const supplierResponseConfig = []
  columnConfig.forEach(item => {
    // 获取品目名称和品目编码的字段配置
    if (
      item.columnType === materialColumnTypeDict.NAME.value ||
      item.columnType === materialColumnTypeDict.CODE.value
    ) {
      materielInfoConfig.push(item)
    }
    // 获取供应商响应且已启用的字段配置
    if (
      item.defineType === materialTemplateDefineTypeDict.RESPONSE.value &&
      item.isEnable
    ) {
      supplierResponseConfig.push(item)
    }
    // 获取采购人指定且已启用的字段配置
    if (
      item.defineType === materialTemplateDefineTypeDict.SPECIFY.value &&
      item.isEnable
    ) {
      purchaseSpecifyConfig.push(item)
    }
  })

  // 由于模板中不存在分类的定义，需要手动添加分类
  materielInfoConfig.push({
    defineCode: 'categoryId',
    columnName: '分类'
  })
  return {
    materielInfoConfig,
    purchaseSpecifyConfig,
    supplierResponseConfig
  }
}

/**
 * 获取授权html
 */
export function generateAwardHtml({
  title = '',
  isDollar = false,
  awardList = [],
  codeConfig,
  nameConfig,
  modelConfig,
  unitPriceConfig,
  controlPriceConfig,
  numConfig,
  unitConfig,
  purchaseSpecifyConfig,
  supplierResponseConfig,
  requireTax,
  showOfferTotalPrice,
  showBargainAmount
}) {
  // 候选供应商
  const materieltableHeader = [
    [
      { content: '采购信息', colspan: 5 },
      { content: title, colspan: 4 }
    ],
    [
      { content: '序号', width: '50px' },
      { content: '品目信息', width: '200px', style: 'text-align: left;' },
      { content: '价格', width: '100px', style: 'text-align: left;' },
      { content: '采购人指定', width: '200px', style: 'text-align: left;' },
      { content: '授标量', width: '50px', style: 'text-align: left;' },
      { content: '供应商名称', width: '200px', style: 'text-align: left;' },
      { content: '供应商响应', width: '200px', style: 'text-align: left;' },
      { content: '报价信息', width: '140px', style: 'text-align: left;' },
      { content: '授标数量', width: '50px', style: 'text-align: left;' }
    ].filter(value => value)
  ]
  const materieltableBody = awardList.map((item, index) => {
    const materiel = item.materiel || {}
    const offer = item.offer || {}
    return [
      // 序号
      {
        content: 1 + index
      },
      // 品目信息
      {
        content: [
          `${codeConfig.columnName}：${materiel[codeConfig.defineCode]}`,
          `${nameConfig.columnName}：${materiel[nameConfig.defineCode]}`,
          `分类：-`,
          `${modelConfig.columnName}：${materiel[modelConfig.defineCode]}`,
          `采购量/计量单位：${materiel[numConfig.defineCode]}/${
            materiel[unitConfig.defineCode]
          }`
        ],
        style: 'text-align: left;'
      },
      // 价格
      {
        content: [
          `预算单价(${isDollar ? '美元' : '元'})：${
            materiel[unitPriceConfig.defineCode]
              ? strToThousands(materiel[unitPriceConfig.defineCode])
              : '-'
          }`,
          `总价(${isDollar ? '美元' : '元'})：${
            materiel.totalPrice ? strToThousands(materiel.totalPrice) : '-'
          }`,
          isDollar
            ? undefined
            : {
              content: `大写：${nzhcn.toMoney(
                parseFloat(materiel.totalPrice || '0'),
                { outSymbol: false }
              )}`,
              style: 'color: #ff4d4f'
            },
          controlPriceConfig.isEnable
            ? `${controlPriceConfig.columnName}(${
              isDollar ? '美元' : '元'
            }) : ${
              materiel[controlPriceConfig.defineCode]
                ? strToThousands(materiel[controlPriceConfig.defineCode])
                : '-'
            }`
            : undefined
        ].filter(value => value),
        style: 'text-align: left;'
      },
      // 采购人指定
      {
        content: purchaseSpecifyConfig.map(p => {
          return `${p.columnName}：${materiel[p.defineCode] || '-'}`
        }),
        style: 'text-align: left;'
      },
      // 授标量
      { content: item.awardNum, style: 'text-align: left;' },
      // 供应商名称
      { content: item.supplierName || '-', style: 'text-align: left;' },
      // 供应商响应
      {
        content: supplierResponseConfig.map(s => {
          return `${s.columnName}：${offer[s.defineCode] || '-'}`
        }),
        style: 'text-align: left;'
      },
      // 报价信息
      {
        content: [
          showOfferTotalPrice
            ? `中标总价（${isDollar ? '美元' : '元'}）:${
              offer.offerTotalPrice
                ? strToThousands(offer.offerTotalPrice)
                : '-'
            }`
            : '',
          requireTax
            ? `含税价(${isDollar ? '美元' : '元'})：${
              offer.offerPrice ? strToThousands(offer.offerPrice) : '-'
            }`
            : '',
          requireTax ? `税率(%)：${offer.offerTaxRate}` : '',
          `未含税价(${isDollar ? '美元' : '元'})：${
            offer.noRateOfferPrice
              ? strToThousands(offer.noRateOfferPrice)
              : '-'
          }`,
          showBargainAmount
            ? `议价(${isDollar ? '美元' : '元'})：${
              offer.bargainAmount ? strToThousands(offer.bargainAmount) : '-'
            }`
            : '',
          `总价(${isDollar ? '美元' : '元'})：${
            offer.offerTotalPrice ? strToThousands(offer.offerTotalPrice) : '-'
          }`,
          isDollar
            ? undefined
            : {
              content: `大写：${nzhcn.toMoney(
                parseFloat(offer.offerTotalPrice || '0'),
                { outSymbol: false }
              )}`,
              style: 'color: #ff4d4f'
            }
        ],
        style: 'text-align: left;'
      },
      // 授标数量
      { content: item.awardNum, style: 'text-align: left;' }
    ].filter(value => value)
  })
  return {
    materieltableHeader,
    materieltableBody
  }
}

/**
 * 生成品目信息
 * @param {*} pdfData
 * @returns
 */
export function generateMaterielHtml({
  pdfData = {},
  pdfTitle = '',
  title = '',
  requireTax = false,
  showBargainAmount = false,
  showOfferTotalPrice = false,
  isDollar = false
}) {
  const yellowStyle = 'color: #faad14;'
  const redStyle = 'color: red;'
  const greenStyle = 'color: green;'
  const fontWeight = 'font-weight: bold;'

  const {
    columnConfig,
    nameConfig,
    codeConfig,
    numConfig,
    unitConfig,
    modelConfig,
    unitPriceConfig,
    controlPriceConfig
  } = setColumnConfig(pdfData.itemSchemaList || [])
  const { purchaseSpecifyConfig, supplierResponseConfig } = setTableConfig(
    columnConfig
  )

  const { materieltableHeader, materieltableBody } = generateAwardHtml({
    awardList: pdfData.awardList || [],
    isDollar,
    showBargainAmount,
    showOfferTotalPrice,
    title,
    codeConfig,
    nameConfig,
    modelConfig,
    controlPriceConfig,
    numConfig,
    unitConfig,
    unitPriceConfig,
    purchaseSpecifyConfig,
    supplierResponseConfig,
    requireTax
  })

  const materieltableHtml = generateTableHtml({
    pdfTitle: pdfTitle,
    describeInfoTop: [
      [
        { label: '询比单名称', content: `${pdfData.orderName}询比单` },
        { label: '项目估算(万元)', content: pdfData.budgetAmount },
        {
          label: '项目负责人',
          content: `${pdfData.releaserEmpName} ${pdfData.releaserMobile}`
        }
      ],
      [{ label: '', content: '候选授标信息', style: fontWeight }]
    ],
    tableHead: { fixedPrev: materieltableHeader },
    tableData: materieltableBody,
    needHtmlWrapper: false,
    noFormat: true
  })

  // 品目比价信息
  const quoteMaterieltableHeader = [
    [
      { content: '采购信息', colspan: 4 },
      { content: '报价供应商', colspan: 6 }
    ],
    [
      { content: '序号', width: '60px', style: 'text-align: left;' },
      { content: '品目信息', width: '200px', style: 'text-align: left;' },
      { content: '价格', width: '100px', style: 'text-align: left;' },
      { content: '采购人指定', width: '200px', style: 'text-align: left;' },
      { content: '供应商名称', width: '200px', style: 'text-align: left;' },
      { content: '报价轮次', width: '50px', style: 'text-align: left;' },
      {
        content: `未含税价(${isDollar ? '美元' : '元'})`,
        width: '70px',
        style: 'text-align: left;'
      },
      requireTax
        ? { content: '税率(%)', width: '50px', style: 'text-align: left;' }
        : '',
      requireTax
        ? {
          content: `含税价(${isDollar ? '美元' : '元'})`,
          width: '70px',
          style: 'text-align: left;'
        }
        : '',
      { content: '供应商响应', width: '200px', style: 'text-align: left;' }
    ].filter(value => value)
  ]
  const quoteMaterieltableBody = pdfData.itemCompareList.map((el, index) => {
    const materiel = el.materiel || {}
    const supplierCompare = el.supplierCompare || {}
    let noRateOfferPriceStyle = ''
    if (supplierCompare.noTaxRateOfferHigh) {
      noRateOfferPriceStyle = redStyle
    }
    if (supplierCompare.noTaxRateOfferLow) {
      noRateOfferPriceStyle = greenStyle
    }
    const offerTaxRateStyle = ''
    let offerPriceStyle = ''
    if (supplierCompare.offerPriceHigh) {
      offerPriceStyle = redStyle
    }
    if (supplierCompare.offerPriceLow) {
      offerPriceStyle = greenStyle
    }
    return [
      // 序号
      {
        content: 1 + index,
        style: 'text-align: left;'
      },
      // 品目信息
      {
        content: [
          `${codeConfig.columnName}：${materiel[codeConfig.defineCode]}`,
          `${nameConfig.columnName}：${materiel[nameConfig.defineCode]}`,
          `分类：-`,
          `${modelConfig.columnName}：${materiel[modelConfig.defineCode]}`,
          `采购量/计量单位：${materiel[numConfig.defineCode]}/${
            materiel[unitConfig.defineCode]
          }`
        ],
        style: 'text-align: left;'
      },
      // 价格
      {
        content: [
          `预算单价(${isDollar ? '美元' : '元'})：${
            materiel[unitPriceConfig.defineCode]
              ? strToThousands(materiel[unitPriceConfig.defineCode])
              : '-'
          }`,
          `总价(${isDollar ? '美元' : '元'})：${
            materiel.totalPrice ? strToThousands(materiel.totalPrice) : '-'
          }`,
          isDollar
            ? undefined
            : {
              content: `大写：${nzhcn.toMoney(
                parseFloat(materiel.totalPrice || '0'),
                { outSymbol: false }
              )}`,
              style: 'color: #ff4d4f'
            },
          controlPriceConfig.isEnable
            ? {
              content: `${controlPriceConfig.columnName}(${
                isDollar ? '美元' : '元'
              }) : ${strToThousands(
                materiel[controlPriceConfig.defineCode]
              ) || '-'}`,
              width: '60px'
            }
            : undefined
        ].filter(value => value),
        style: 'text-align: left;'
      },
      // 采购人指定
      {
        content: purchaseSpecifyConfig.map(
          p => `${p.columnName}：${materiel[p.defineCode] || '-'}`
        ),
        style: 'text-align: left;'
      },
      // 供应商名称
      {
        content: supplierCompare.supplierName || '-',
        style: 'text-align: left;'
      },
      // 报价轮次
      {
        content: supplierCompare.roundName,
        style: supplierCompare.currentRound
          ? 'text-align: left;'
          : 'text-align: left;' + yellowStyle
      },
      // 未含税价
      {
        content: supplierCompare.noRateOfferPrice
          ? strToThousands(supplierCompare.noRateOfferPrice)
          : '-',
        style: 'text-align: left;' + noRateOfferPriceStyle
      },
      // 税率
      requireTax
        ? {
          content: supplierCompare.offerTaxRate,
          style: 'text-align: left;' + offerTaxRateStyle
        }
        : '',
      // 含税价
      requireTax
        ? {
          content: supplierCompare.offerPrice
            ? strToThousands(supplierCompare.offerPrice)
            : '-',
          style: 'text-align: left;' + offerPriceStyle
        }
        : '',
      // 供应商响应
      {
        content: supplierResponseConfig.map(
          s => `${s.columnName}：${supplierCompare[s.defineCode] || '-'}`
        ),
        style: 'text-align: left;'
      }
    ].filter(value => value)
  })
  // 报价供应商
  const quoteMaterieltableHtml = generateTableHtml({
    describeInfoTop: [
      [{ label: '', content: '品目比价信息', style: fontWeight }]
    ],
    tableHead: { fixedPrev: quoteMaterieltableHeader },
    tableData: quoteMaterieltableBody,
    needHtmlWrapper: false,
    noFormat: true
  })
  const tableHtml = tableHtmlWrapper(
    materieltableHtml + quoteMaterieltableHtml,
    pdfTitle
  )
  return tableHtml
}
